module.exports = __webpack_public_path__ + "static/img/brees-2019-slide-1.f7a568f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2019-slide-1.jpg
// module id = rD9Y
// module chunks = 1